import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./feh-product-cards.lazy.module').then(
    (module) => module.FehProductCardsLazyModule
  );

export const fehProductCardsLazyImports: ComponentNameAndModule[] = [
  {
    path: 'FehProductCardsOverview',
    canActivate: [],
    loadChildren,
  },
];
